<template>
    <div class="printServiceAuthenticationBox">
        <div class="printBanner">
            <div class="printBannerContent">
                <h1>我要打印</h1>
                <h3>——增材云打印服务商入驻</h3>
            </div>
        </div>
        <div class="serviceAuthenticationContent">
            <ul class="articleSteps">
                <li v-for="item in stepsList" :key="item.id"
                    :class="currentStepId >= item.id?currentStepId === item.id?'active':'before':''">
                    <div :class="item.id === '5'?currentStepId === '5'?examineStatus === 'REFUSE'?'examineError stepsContent':examineStatus === 'PASS'?'examineSuccess stepsContent':'stepsContent':'stepsContent':'stepsContent'">
                        <div class="num">{{item.num}}</div>
                        <div class="name">{{item.id === '5'?currentStepId === '5'?examineStatus === 'REFUSE'?'审核失败':examineStatus === 'PASS'?'审核成功':'等待审核':'等待审核':item.name}}</div>
                    </div>
                    <div class="line" v-if="item.id !== '5'"></div>
                </li>
            </ul>
            <div class="comment">
                <!--入住须知-->
                <div class="commentItem" v-show="currentStepId === '0'">
                    <div class="commentItemContent" style="padding: 20px 0">
                        <el-scrollbar style="height: 500px">
                            <div style="padding: 0 30px 30px">
                                <h3>{{ contentTitle }}</h3>
                                <div v-html="content" class="vHtmlMess"></div>
                                <!--<p>
                                    为保障增材云平台用户合法权益，维护增材云平台正常经营秩序，根据国家相关法律法规制定《增材云平台服务协议》（以下简称《平台协议》或本协议），本协议具有合同效力。用户注册时，请您认真阅读本协议，审阅并接受或不接受本协议（未成年人应在法定监护人陪同下审阅）。</p>
                                <p>第一条 接受协议</p>
                                <p>本协议内容包括协议正文及所有增材云平台已经发布或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。</p>
                                <p>
                                    您在点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可致电（4000666595）向增材云平台客服咨询。</p>
                                <p>
                                    当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序，或以任何方式进入增材云平台并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序并停止使用服务。</p>
                                <p>
                                    本平台有权随时变更本协议并在本平台上予以公告。经修订的条款一经在本平台的公布后，立即自动生效。如果您拒绝接受新的协议，您必须放弃使用增材云平台提供的服务；若您继续使用增材云平台提供的服务，则表明您已阅读、理解、认可并接受新的协议。</p>
                                <p>
                                    用户在增材云平台进行企业认证时，应当认真阅读并同意接受本规则约束，不同意接受本规则的，不能进行认证和使用增材云平台的各项服务；同理，用户使用平台服务即视同接受本规则。</p>
                                <p>第二条 用户资格</p>
                                <p>只有符合下列条件之一的自然人或法人才能申请成为增材云平台用户，可以使用增材云平台的服务。</p>
                                <p>(一) 年满十八岁，并具有民事权利能力和民事行为能力的自然人；</p>
                                <p>(二) 无民事行为能力人或限制民事行为能力人应经过其监护人的同意；</p>
                                <p>(三) 根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。无法人资格的单位或组织不当注册为增材云平台用户的，其与增材云平台</p>
                                <p>第二条 用户资格</p>
                                <p>只有符合下列条件之一的自然人或法人才能申请成为增材云平台用户，可以使用增材云平台的服务。</p>
                                <p>(一) 年满十八岁，并具有民事权利能力和民事行为能力的自然人；</p>
                                <p>(二) 无民事行为能力人或限制民事行为能力人应经过其监护人的同意；</p>
                                <p>(三) 根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。无法人资格的单位或组织不当注册为增材云平台用户的，其与增材云平台</p>

                                <p>第二条 用户资格</p>
                                <p>只有符合下列条件之一的自然人或法人才能申请成为增材云平台用户，可以使用增材云平台的服务。</p>
                                <p>(一) 年满十八岁，并具有民事权利能力和民事行为能力的自然人；</p>
                                <p>(二) 无民事行为能力人或限制民事行为能力人应经过其监护人的同意；</p>
                                <p>(三) 根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。无法人资格的单位或组织不当注册为增材云平台用户的，其与增材云平台</p>
                                <p>第二条 用户资格</p>
                                <p>只有符合下列条件之一的自然人或法人才能申请成为增材云平台用户，可以使用增材云平台的服务。</p>
                                <p>(一) 年满十八岁，并具有民事权利能力和民事行为能力的自然人；</p>
                                <p>(二) 无民事行为能力人或限制民事行为能力人应经过其监护人的同意；</p>
                                <p>(三) 根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。无法人资格的单位或组织不当注册为增材云平台用户的，其与增材云平台</p>-->
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="conventionButton" @click="currentStepId = '1'">开始申请</el-button>
                    </div>
                </div>
                <!--公司联系人-->
                <div class="commentItem" v-show="currentStepId === '1'">
                    <div class="commentItemContent">
                        <div class="explain">
                            <i class="el-icon-warning-outline"></i>说明：用于入驻过程中接收平台反馈通知、联络，请务必填写正确
                        </div>
                        <el-form :model="contactsForm" :rules="contactsRules" ref="contactsFormRef" label-width="120px"
                                 class="contactsFormClass">
                            <el-form-item label="联系人姓名:" prop="companyPerson">
                                <el-input v-model="contactsForm.companyPerson" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人电话:" prop="companyTel">
                                <el-input v-model="contactsForm.companyTel" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人邮箱:" prop="companyEmail">
                                <el-input v-model="contactsForm.companyEmail" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="conventionButton" @click="submitContactsForm">下一步</el-button>
                        <!--<el-button class="Staging" type="text">暂存</el-button>-->
                    </div>
                </div>
                <!--开户行-->
                <div class="commentItem" v-show="currentStepId === '2'">
                    <div class="commentItemContent">
                        <div class="explain">
                            <i class="el-icon-warning-outline"></i>说明：用于店铺结算，请务必填写正确
                        </div>
                        <el-form :model="contactsForm" :rules="openingBankRules" ref="openingBankFormRef"
                                 label-width="150px" class="contactsFormClass">
                            <el-form-item label="银行名称:" prop="bankName">
                                <el-input v-model="contactsForm.bankName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户银行支行:" prop="bankSubbranch">
                                <el-input v-model="contactsForm.bankSubbranch" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户名:" prop="accountNumber">
                                <el-input v-model="contactsForm.accountNumber" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="银行账号:" prop="backAccount">
                                <el-input v-model="contactsForm.backAccount" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户支行联行号:">
                                <el-input v-model="contactsForm.accountBankSubbranch" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="backButton" @click="currentStepId = '1'">返回上一级</el-button>
                        <el-button class="conventionButton" @click="submitOpeningBankForm">下一步</el-button>
                        <!--<el-button class="Staging" type="text">暂存</el-button>-->
                    </div>
                </div>
                <!--主页信息-->
                <div class="commentItem" v-show="currentStepId === '3'">
                    <div class="commentItemContent">
                        <el-form :model="contactsForm" :rules="storeInformationRules" ref="storeInformationFormRef"
                                 label-width="150px" class="storeInformationFormClass">
                            <div class="title">·基本信息</div>
                            <el-form-item label="主页名称" prop="storeName">
                                <el-input v-model="contactsForm.storeName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-row class="addressSelect">
                                <el-col :span="12">
                                    <el-form-item label="地址" prop="storeCity">
                                        <el-cascader
                                            v-model="contactsForm.storeCity"
                                            :options="regionOptions"
                                            placeholder="省/市/区"
                                            style="width: 334px"
                                        ></el-cascader>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="detailAddress" class="storeAddress">
                                        <el-input v-model="contactsForm.storeAddress" placeholder="请输入"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!--<div class="title">·店铺有效期</div>-->
                            <!--<el-form-item prop="periodDate" label="有效期">-->
                            <!--<el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期" v-model="contactsForm.periodDate" style="width: 750px;"></el-date-picker>-->
                            <!--</el-form-item>-->
                            <!--<div class="title">·经营类目</div>
                            <el-form-item label="服务行业" prop="serviceId">
                                <el-checkbox-group v-model="contactsForm.serviceId">
                                    <el-checkbox :label="item.uuid" v-for="item in serviceList" :key="item.uuid">{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="打印材料" prop="materialId">
                                <el-checkbox-group v-model="contactsForm.materialId">
                                    <el-checkbox :label="item.uuid" v-for="item in materialList" :key="item.uuid">{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>-->
                        </el-form>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="backButton" @click="currentStepId = '2'">返回上一级</el-button>
                        <el-button class="conventionButton" @click="submitStoreInformationForm">下一步</el-button>
                        <!--<el-button class="Staging" type="text">暂存</el-button>-->
                    </div>
                </div>
                <!--在线协议-->
                <div class="commentItem" v-show="currentStepId === '4'" v-loading="loading">
                    <div class="commentItemContent" style="padding: 20px 0">
                        <el-scrollbar style="height: 500px">
                            <div style="padding: 0 30px 30px">
                                <h3>{{ contentTitle }}</h3>
                                <div v-html="content" class="vHtmlMess"></div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <el-checkbox style="padding-top: 15px;" v-model="checkedAgree" :disabled="countDownNum > 0">
                        我已仔细阅读，并同意协议
                    </el-checkbox>
                    <span style="padding-left: 10px;" v-show="countDownNum > 0"><span style="color:#3d7fff">{{countDownNum}}</span> s</span>
                    <div class="commentItemButtonGroup">
                        <el-button class="backButton" @click="currentStepId = '3',checkedAgree = false,countDownNum = 5">返回上一级</el-button>
                        <el-button class="conventionButton" @click="submitApply">提交入驻申请</el-button>
                    </div>
                </div>
                <!--等待审核-->
                <div class="commentItem" v-show="currentStepId === '5'">
                    <div class="commentItemContent">
                        <div style="padding-bottom: 40px;" v-show="examineStatus === 'PASS'">

                        </div>
                        <div class="explain" style="margin-bottom: 40px;" v-show="examineStatus !== 'PASS'">
                            <i class="el-icon-warning-outline"></i>
                            <span v-show="examineStatus === 'REFUSE'">驳回原因：{{contactsForm.remark}}</span>
                            <span v-show="examineStatus !== 'PASS' && examineStatus !== 'REFUSE'">说明：平台将于7个工作日内审核反馈，请您注意查看系统信息。</span>
                        </div>
                        <div class="table">
                            <ul class="header">
                                <li>步骤</li>
                                <li>状态</li>
                            </ul>
                            <div class="tableBody">
                                <ul class="tableItem">
                                    <li>填写入驻信息</li>
                                    <li><i class="el-icon-success"></i>已完成</li>
                                </ul>
                                <ul class="tableItem">
                                    <li>提交入驻申请</li>
                                    <li><i class="el-icon-success"></i>已完成</li>
                                </ul>
                                <ul class="tableItem">
                                    <li>店铺信息认证</li>
                                    <li v-if="examineStatus === 'EXAMINE'"><i class="el-icon-warning"></i>审核中</li>
                                    <li v-if="examineStatus === 'PASS'"><i class="el-icon-success"></i>已完成</li>
                                    <li v-if="examineStatus === 'REFUSE'"><i class="el-icon-error"></i>审核失败</li>
                                </ul>
                                <ul class="tableItem" v-if="examineStatus === 'PASS'">
                                    <li>开户申请</li>
                                    <li v-if="applicationStatus === ''"><i class="el-icon-info"></i>未开户</li>
                                    <li v-if="applicationStatus === 'REVIEW_BACK'"><i class="el-icon-error"></i>开户失败</li>
                                    <li v-if="applicationStatus === 'COMPLETED'"><i class="el-icon-success"></i>已开户</li>
                                    <li v-if="applicationStatus !== ''
                                    &&applicationStatus !== 'COMPLETED'&&applicationStatus !== 'REVIEW_BACK'"><i class="el-icon-warning"></i>开户中</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="conventionButton" v-if="examineStatus === 'PASS'" @click="openAddress">开户申请</el-button>
                        <el-button class="conventionButton" @click="openNewAddress" v-if="examineStatus === 'PASS'">维护打印材料</el-button>
                        <el-button class="conventionButton" @click="currentStepId = '0'" v-if="examineStatus === 'REFUSE'">重新审核</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        saveProvidersInfo,
        getDictionaryItem,
        getDictionaryGroup,
        findProvidersInfo,
        getExamineStatusInfo,
        getNewcurrent,
        getInfoByWordNo,
        getEnterpriseCredentials,
        merchantCurrent,
    } from "../../utils/interface";
    import provinceData from "../../utils/provinceData";

    export default {
        name: "printServiceAuthentication",
        components: {provinceData},
        data() {
            return {
                loading: false,
                currentStepId: '0',
                applicationStatus:"",
                stepsList: [
                    {
                        id: '0',
                        num: '1',
                        name: '入驻须知'
                    },
                    {
                        id: '1',
                        num: '2',
                        name: '公司联系人'
                    },
                    {
                        id: '2',
                        num: '3',
                        name: '开户行'
                    },
                    {
                        id: '3',
                        num: '4',
                        name: '主页信息'
                    },
                    {
                        id: '4',
                        num: '5',
                        name: '在线协议'
                    },
                    {
                        id: '5',
                        num: '6',
                        name: '等待审核'
                    }
                ],
                contactsForm: {
                    companyPerson: '',
                    companyTel: '',
                    companyEmail: '',
                    bankName: '',
                    bankSubbranch: '',
                    accountNumber: '',
                    backAccount: '',
                    accountBankSubbranch: '',
                    storeName: '',
                    storeCity: [],
                    storeAddress: '',
                    // periodDate: '',
                    serviceId: [],
                    materialId: [],
                    isAgree: 0,
                    examineStatus: 1,
                },
                contactsRules: {
                    companyPerson: [
                        {required: true, message: '请输入联系人名称', trigger: 'blur'}
                    ],
                    companyTel: [
                        {required: true, validator: this.validatorPhone, trigger: 'blur'}
                    ],
                    companyEmail: [
                        {required: true, validator: this.validatorEmail, trigger: 'blur'}
                    ]
                },
                openingBankRules: {
                    bankName: [
                        {required: true, message: '请输入银行名称', trigger: 'blur'}
                    ],
                    bankSubbranch: [
                        {required: true, message: '请输入开户银行支行', trigger: 'blur'}
                    ],
                    accountNumber: [
                        {required: true, message: '请输入开户名', trigger: 'blur'}
                    ],
                    backAccount: [
                        {required: true, trigger: 'blur', validator: this.validatorBackNo }
                    ]
                },
                storeInformationRules: {
                    storeName: [
                        {required: true, message: '请输入主页名称', trigger: 'blur'}
                    ],
                    storeCity: [
                        {required: true, message: '请选择地址', trigger: 'change'}
                    ],
                    storeAddress: [
                        {required: true, message: '请输入详细地址', trigger: 'blur'}
                    ],
                    periodDate: [
                        {required: true, message: '请选择有效期', trigger: 'change'}
                    ],
                    /*serviceId:  [
                        { required: true, message: '请选择服务行业',trigger: 'change' }
                    ],
                    materialId: [
                        { required: true, message: '请选择打印材料',trigger: 'change' }
                    ],*/
                },
                regionOptions: provinceData,
                checkedAgree: false,
                countDownNum: 5,
                serviceList: [],
                materialList: [],
                isService: false,
                examineStatus: '',
                content:"",
                contentTitle:"",
            }
        },
        created() {
            merchantCurrent().then((res)=>{
                if(res.success){
                    this.applicationStatus = res.data.applicationStatus;
                }else {
                    this.applicationStatus = "";
                }
            });
			let newToken = this.$cookies.get("api_token_new");
			if(newToken){
				getInfoByWordNo({"wordNo":"DYFWSRZ"}).then((res)=>{
				    if(res&&res.data){
				        this.content = res.data.content;
				        this.contentTitle = res.data.title;
				    }
				});
				this.getDictionary();
				this.isServiceAuthentication();
			}else{
				this.$router.push('/print')
			}
           
        },
        methods: {
            openAddress(){
                window.open(this.$url.sellerWeb+"/#/accountManagement",'_target');
            },
            openNewAddress(){
                window.open(this.$url.sellerWeb+"/#/materialManagement",'_target');
            },
            // 电话号码校验
            validatorPhone(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入联系人电话'))
                } else if (!/^1\d{10}$/.test(value)) {
                    callback(new Error('请输入正确的电话号码'))
                } else {
                    callback()
                }
            },
            validatorBackNo(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入银行卡号'))
                } /*else if(value.length < 16 || value.length > 19) {
                    callback(new Error('银行卡号长度必须在16到19之间'));
                }*/ else if(!this.validate.isDigits(value)) {
                    callback(new Error('银行卡号必须全为数字'));
                } /*else if(!this.validate.isBankSecondNumber(value)) {
                    callback(new Error('银行卡号开头6位不符合规范'));
                }*/ /*else if (!this.validate.isBankNo(value)) {
                    callback(new Error('请输入正确的银行卡号'));
                }*/ else {
                    callback();
                }
            },
            validatorEmail(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入联系人邮箱'))
                } else if (!this.validate.isEmail(value)) {
                    callback(new Error('请输入正确的邮箱地址'))
                } else {
                    callback()
                }
            },
            // 公司联系人表单提交
            submitContactsForm() {
                this.$refs.contactsFormRef.validate((valid) => {
                    if (valid) {
                        this.currentStepId = '2'
                    } else {
                        return false;
                    }
                });
            },
            // 开户行表单提交
            submitOpeningBankForm() {
                this.$refs.openingBankFormRef.validate((valid) => {
                    if (valid) {
                        this.currentStepId = '3'
                    } else {
                        return false;
                    }
                });
            },
            // 店铺信息表单提交
            submitStoreInformationForm() {
                this.$refs.storeInformationFormRef.validate((valid) => {
                    if (valid) {
                        this.currentStepId = '4'
                        this.countDown()
                    } else {
                        return false;
                    }
                });
            },
            // 提交入住申请
            submitApply() {
                if (this.checkedAgree) {
                    this.loading = true
                    this.contactsForm.storeCity = this.contactsForm.storeCity.join(",");
                    // this.contactsForm.serviceId = this.contactsForm.serviceId.join(",");
                    // this.contactsForm.materialId = this.contactsForm.materialId.join(",");
                    this.contactsForm.isAgree = 1;
                    saveProvidersInfo(this.contactsForm).then(result => {
                        this.isServiceAuthentication()
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    });
                } else {
                    this.$message({
                        message: '请阅读并同意入驻协议！',
                        type: 'warning'
                    })
                }
            },
            countDown() {
                if (this.currentStepId === '4') {
                    this.countDownNum = 5
                    this.timer = setInterval(() => {
                        this.countDownNum--
                        if (this.countDownNum === 0) {
                            clearInterval(this.timer)
                        }
                    }, 1000)
                }
            },
            // 获取字典值
            getDictionary() {
                // 服务行业
                getDictionaryItem({groupCode: 'server_print'}).then((res) => {
                    this.serviceList = res;
                });
                // 打印材料
                getDictionaryGroup({parentCode: 'material_print'}).then((res) => {
                    this.materialList = res;
                });
                // 获取当前用户信息
                getNewcurrent().then((data) => {
                    getEnterpriseCredentials({userUuid:data.uuid}).then((res)=>{
                        if(res.success){
                            this.contactsForm.companyTel = res.data.contactTel;
                            this.contactsForm.companyEmail = res.data.contactMail;
                            this.contactsForm.companyPerson = res.data.contact;
                        }
                    });
                })
            },
            // 判断是否认证成功
            isServiceAuthentication() {
                getExamineStatusInfo().then(res=>{
                    this.examineStatus = res.data?res.data.examineStatus: ''
                    if (res.data && res.data.examineStatus === 'PASS') {
                        this.isService = false;
                        this.currentStepId = '5';
                    } else if (res.data && res.data.examineStatus === 'EXAMINE') {
                        this.isService = false;
                        this.currentStepId = '5';
                    } else if (res.data && res.data.examineStatus === 'REFUSE') {
                        this.isService = true;
                        this.currentStepId = '5';
                    } else {
                        this.isService = true
                        this.currentStepId = '0';
                    }
                    findProvidersInfo().then((res) => {
                        if (res.data) {
                            console.log(this.isService)
                            this.contactsForm = res.data
                            this.contactsForm.storeCity = this.contactsForm.storeCity.split(",");
                            // this.contactsForm.serviceId = this.contactsForm.serviceId.split(",");
                            // this.contactsForm.materialId = this.contactsForm.materialId.split(",");
                        }
                    })
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .printServiceAuthenticationBox {
        background: rgb(244, 244, 244);

        .printBanner {
            width: 100%;
            height: 448px;
            background: url("../../assets/我要打印/20220210150305.png") no-repeat left center;
            background-size: 100% 100%;
            color: #fff;

            .printBannerContent {
                width: 1200px;
                margin: 0 auto;
                padding-top: 130px;

                h1 {
                    font-weight: 700;
                    font-style: normal;
                    font-size: 30px;
                    padding-bottom: 30px;
                }

                h3 {
                    font-weight: 700;
                    font-style: normal;
                    font-size: 25px;
                }
            }
        }

        .serviceAuthenticationContent {
            width: 1200px;
            margin: 0 auto;
            background: #fff;
            border-radius: 10px;
            position: relative;
            top: -90px;
            box-sizing: border-box;
            padding: 30px 50px;

            .articleSteps {
                display: flex;
                justify-content: space-around;
                text-align: center;

                li {
                    font-weight: 400;
                    display: flex;
                    align-items: center;

                    .line {
                        height: 1px;
                        width: 98px;
                        background: #c0c0c0;
                        position: relative;
                        top: -14px;
                        left: 26px;
                    }

                    .num {
                        margin: 0 auto 15px;
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                        text-align: center;
                        line-height: 34px;
                        border: 1px solid #dddddd;
                        color: #c0c0c0;
                        font-size: 13px;
                    }

                    .name {
                        color: rgba(0, 0, 0, 0.447058823529412);
                        font-size: 15px;
                    }

                    &:hover {
                        color: #1890FF;
                    }

                    &.active {
                        font-weight: 700;

                        .num {
                            color: #fff;
                            background: #1890FF;
                            border: 1px solid #1890FF;
                        }

                        .name {
                            color: #1890FF;
                        }
                    }
                    .examineError{
                        .num {
                            color: #fff;
                            background: #ff0000;
                            border: 1px solid #ff0000;
                        }

                        .name {
                            color: #ff0000;
                        }
                    }
                    .examineSuccess{
                        .num {
                            color: #fff;
                            background: #009900;
                            border: 1px solid #009900;
                        }

                        .name {
                            color: #009900;
                        }
                    }
                    &.before {
                        .num {
                            color: #1890FF;
                            border: 1px solid #1890FF;
                            background: #fff;
                        }

                        .name {
                            color: #1890FF;
                        }

                        .line {
                            background: #1890FF;
                        }
                    }
                }
            }

            .comment {
                padding-top: 30px;

                .commentItem {
                    position: relative;

                    .commentItemContent {
                        width: 100%;
                        border-radius: 5px;
                        box-shadow: 0 0 10px rgba(16, 141, 233, 0.176470588235294);
                        padding: 0 30px 60px;
                        box-sizing: border-box;

                        h3 {
                            font-weight: 700;
                            font-size: 16px;
                            color: #333333;
                            padding: 30px 0 20px;
                            text-align: center;
                        }

                        p {
                            line-height: 25px;
                            font-weight: 400;
                            font-size: 13px;
                            color: #333333;
                        }

                        .explain {
                            width: 100%;
                            height: 58px;
                            background-color: rgba(255, 251, 230, 1);
                            box-sizing: border-box;
                            border: 1px solid rgba(255, 229, 143, 1);
                            border-radius: 4px;
                            color: #999999;
                            line-height: 56px;
                            padding: 0 50px;
                            margin: 30px 0 70px;
                            display: inline-flex;
                            font-size: 13px;

                            i {
                                line-height: 58px;
                                font-size: 22px;
                                padding-right: 10px;
                                color: #faad14;
                            }
                        }

                        .contactsFormClass {
                            /deep/ form {
                                width: 700px;
                                margin: 0 auto;
                            }

                            /deep/ .el-form-item {
                                margin-bottom: 30px;
                            }

                            /deep/ .el-form-item__label {
                                padding-right: 30px;
                            }
                        }

                        .storeInformationFormClass {
                            padding-top: 35px;

                            /deep/ .el-form-item {
                                margin-bottom: 30px;
                            }

                            /deep/ .el-form-item__label {
                                padding-right: 30px;
                            }

                            /deep/ .el-form-item__content {
                                /*width: 750px;*/
                            }

                            .title {
                                font-weight: 700;
                                font-size: 14px;
                                color: #000;
                                padding-bottom: 30px;
                            }

                            .addressSelect {
                                display: flex;

                                .detailAddressClass {
                                    /deep/ .el-input__inner {
                                        width: 380px;
                                    }

                                    /deep/ .el-form-item__content {
                                        margin-left: 0 !important;
                                    }
                                }
                            }

                            .el-radio {
                                margin-right: 10px;
                                min-width: 110px;
                                padding-bottom: 5px;
                            }
                        }

                        .table {
                            width: 880px;
                            margin: 0 auto;
                            border-left: 1px solid #ddd;
                            border-top: 1px solid #ddd;

                            ul {
                                display: flex;
                                width: 100%;

                                &.header {
                                    background: #d5ebfb;

                                    li {
                                        line-height: 40px;
                                        font-weight: 700;
                                        font-style: normal;
                                        color: rgba(51, 51, 51, 0.71)
                                    }
                                }

                                li {
                                    width: 50%;
                                    text-align: center;
                                    line-height: 50px;
                                    color: #333333;
                                    font-size: 13px;
                                    border-bottom: 1px solid #ddd;
                                    border-right: 1px solid #ddd;

                                    i {
                                        padding-right: 10px;
                                        font-size: 20px;
                                        vertical-align: middle;

                                        &.el-icon-success {
                                            color: #009900
                                        }

                                        &.el-icon-warning {
                                            color: #faad14
                                        }
                                        &.el-icon-error{
                                            color: #ff0000;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .commentItemButtonGroup {
                        width: 100%;
                        text-align: center;
                        padding-top: 30px;

                        .conventionButton {
                            width: 111px;
                            height: 33px;
                            background-color: rgba(61, 127, 255, 1);
                            border: none;
                            border-radius: 15px;
                            font-weight: 400;
                            color: #FFFFFF;
                            padding: 0;
                            text-align: center;
                            line-height: 33px;

                            &:hover {
                                background-color: #0057ff;
                            }
                        }

                        .Staging {
                            padding: 0 0 0 15px;
                            line-height: 33px;
                            color: #3D7FFF;

                            &:hover {
                                color: #0057ff;
                            }
                        }

                        .backButton {
                            width: 111px;
                            height: 33px;
                            background-color: #fff;
                            border: 1px solid #3D7FFF;
                            border-radius: 15px;
                            font-weight: 400;
                            color: #3D7FFF;
                            padding: 0;
                            text-align: center;
                            line-height: 33px;

                            &:hover {
                                background-color: rgba(61, 127, 255, 1);
                                color: #fff;
                            }
                        }
                    }
                }
            }

            .storeAddress {
                /deep/ .el-form-item__content {
                    margin-left: 0 !important;
                }
            }
        }

        /deep/ .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/printServiceAuthentication.vue